import { render, staticRenderFns } from "./administrative_functions.vue?vue&type=template&id=194ed314&scoped=true"
import script from "./administrative_functions.vue?vue&type=script&lang=js"
export * from "./administrative_functions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194ed314",
  null
  
)

export default component.exports